import { object, string, number, date, InferType, boolean } from 'yup';
export const validations = {
    subject: string().required('Field is required'),
    name: string()
        .matches(/^[A-Za-z\s]+$/, 'Not allowed special characters')
        .required('Field is required'),
    phone: string()
        .matches(/^(\+?\d+(\s\d+)*)?$/, 'Check your phone number')
        .required('Field is required'),
    terms: boolean().oneOf([true], 'Required'),
    email: string()
        .email('Invalid email address')
        .required('Email is required'),
};